module.exports = __webpack_public_path__ + "front/img/14.04a5e57c.jpg";